import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { host_url } from '../../../App'; // Import host_url
import Cookies from 'js-cookie'; // Import js-cookie
import { MdKeyboardArrowDown } from "react-icons/md";
import '../../../styles/CiTable.css';
import BackArrow from '../../../BackArrow'; // Importiere die BackArrow-Komponente

function Kinderliste() {
    const navigate = useNavigate();
    const [zelte, setZelte] = useState([]);
    const [kinder, setKinder] = useState([]);
    const [alleKinder, setAlleKinder] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedZelt, setSelectedZelt] = useState('');

    useEffect(() => {
        // Fetch zelte data
        fetch(`${host_url}/zelte`)
            .then(response => response.json())
            .then(data => {
                const sorted = data.sort((a, b) => a.Zeltname.localeCompare(b.Zeltname));
                setZelte(sorted);
            })
            .catch(error => console.error('Error fetching zelte:', error));
            
        fetch(`${host_url}/allekinder`)
            .then(response => response.json())
            .then(data => {
                setAlleKinder(data);
            })
            .catch(error => console.error('Error fetching all kinder:', error));

        const savedZeltID = Cookies.get('selectedZelt');
        if (savedZeltID) setSelectedZelt(savedZeltID);
    }, []);

    useEffect(() => {
        if (selectedZelt) {
            // Fetch kinder data based on selectedZelt
            fetch(`${host_url}/kinder?zeltId=${selectedZelt}`)
                .then(response => response.json())
                .then(data => {
                    const sorted = data.sort((a, b) => a.Name.localeCompare(b.Name));
                    setKinder(sorted);
                })
                .catch(error => console.error('Error fetching kinder:', error));
            Cookies.set('selectedZelt', selectedZelt);
        } else {
            setKinder([]);
            Cookies.remove('selectedZelt');
        }
    }, [selectedZelt]);

    const handleZeltChange = (e) => {
        setSelectedZelt(e.target.value);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    return (
        <div>
            <div className="page-header">
                <BackArrow to="/jobportal" />
                <h1>Kinderliste</h1>
            </div>
            <div className="kinderliste-form dropdown-form">
                <label>
                    Zelt
                    <div className={`dropdown-wrapper ${selectedZelt ? 'filled' : ''}`}>
                        <select id="zelt" name="zelt" value={selectedZelt} onChange={handleZeltChange}>
                            <option value="">Wähle ein Zelt</option>
                            {zelte.map(zelt => (
                                <option key={zelt.ZeltID} value={zelt.ZeltID}>{zelt.Zeltname}</option>
                            ))}
                        </select>
                        <MdKeyboardArrowDown className="dropdown-chevron" />
                    </div>
                </label>
            </div>
            <div className="ci-table-wrapper">
                {!selectedZelt ? (
                    <p>Wähle ein Zelt, um die Kinder des Zelts zu sehen.</p>
                ) : (
                <table className="ci-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Nachname</th>
                        </tr>
                    </thead>
                    <tbody>
                        {kinder
                            .filter(kind => kind.Name.toLowerCase().includes(searchTerm.toLowerCase()) || (kind.Nachname && kind.Nachname.toLowerCase().includes(searchTerm.toLowerCase())))
                            .map(kind => (
                                <tr key={kind.KindID} className="clickable-row" onClick={() => navigate(`/jobs/kinderliste/kind/${kind.KindID}`)}>
                                    <td>{kind.Name}</td>
                                    <td>{kind.Nachname}</td>
                                </tr>
                        ))}
                    </tbody>
                </table>
                )}
                <label>
                    <h2>
                    Kind suchen:
                    </h2>
                    <input
                        type="text"
                        placeholder="Namen suchen..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                </label>
                <table className="ci-table kindersuche-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Nachname</th>
                            <th>Zelt</th>
                        </tr>
                    </thead>
                    <tbody>
                        {alleKinder.filter(kind => kind.Name.toLowerCase().includes(searchTerm.toLowerCase()) || (kind.Nachname && kind.Nachname.toLowerCase().includes(searchTerm.toLowerCase()))).map(kind => (
                            <tr key={kind.KindID} className="clickable-row" onClick={() => navigate(`/jobs/kinderliste/kind/${kind.KindID}`)}>
                                <td>{kind.Name}</td>
                                <td>{kind.Nachname}</td>
                                <td className="zelt-cell">
                                    <span className="zelt-name">{kind.Zeltname}</span>
                                    {kind.Zeltbetreuer && (
                                        <span className="zelt-betreuer">{kind.Zeltbetreuer}</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Kinderliste;
